import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import WebIcon from '@mui/icons-material/Web';
import DevicesIcon from '@mui/icons-material/Devices';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const allservices = [
  {
    name: 'RTMP Streaming',
    icon: <LiveTvIcon sx={{ fontSize: 38 }} />,
    color: '#e53935',
    bgColor: 'rgba(229, 57, 53, 0.08)',
    borderColor: 'rgba(229, 57, 53, 0.18)',
    desc:
      'High-performance RTMP streaming with low-latency servers, reliable ingest, and customized configurations for every use case.',
  },
  {
    name: 'SRT Streaming',
    icon: <SettingsInputAntennaIcon sx={{ fontSize: 38 }} />,
    color: '#0288d1',
    bgColor: 'rgba(2, 136, 209, 0.08)',
    borderColor: 'rgba(2, 136, 209, 0.18)',
    desc:
      'Secure Reliable Transport streaming built for challenging network conditions — low latency, encrypted, and resilient end-to-end.',
  },
  {
    name: 'WebApp Development',
    icon: <WebIcon sx={{ fontSize: 38 }} />,
    color: '#388e3c',
    bgColor: 'rgba(56, 142, 60, 0.08)',
    borderColor: 'rgba(56, 142, 60, 0.18)',
    desc:
      'Custom web apps built to your specifications — from responsive web apps optimized for search engines',
  },
  {
    name: 'MobileApp Development',
    icon: <DevicesIcon sx={{ fontSize: 38 }} />,
    color: '#7b1fa2',
    bgColor: 'rgba(123, 31, 162, 0.08)',
    borderColor: 'rgba(123, 31, 162, 0.18)',
    desc:
      'Custom mobile apps built to your specifications — from Android apps published to the Play Store',
  },
];

const ServiceCard = ({ data }) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      border: `1px solid ${data.borderColor}`,
      borderRadius: '20px',
      background: '#fff',
      transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: `0 20px 60px ${data.bgColor.replace('0.08', '0.25')}`,
        borderColor: data.color,
        '& .service-arrow': { opacity: 1, transform: 'translateX(0)' },
      },
    }}
  >
    <CardActionArea sx={{ height: '100%', alignItems: 'flex-start' }}>
      <CardContent sx={{ p: { xs: 3, md: 3.5 }, height: '100%' }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '18px',
            background: data.bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: data.color,
            mb: 2.5,
          }}
        >
          {data.icon}
        </Box>
        <Typography
          component="h3"
          sx={{
            fontWeight: 700,
            fontSize: '1.1rem',
            color: '#0d1757',
            mb: 1.5,
          }}
        >
          {data.name}
        </Typography>
        <Typography
          sx={{
            color: '#6b7280',
            fontSize: '0.9rem',
            lineHeight: 1.75,
            mb: 2,
          }}
        >
          {data.desc}
        </Typography>
        <Box
          className="service-arrow"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: data.color,
            fontSize: '0.85rem',
            fontWeight: 600,
            opacity: 0,
            transform: 'translateX(-6px)',
            transition: 'all 0.3s ease',
          }}
        >
          Learn more <ArrowForwardIcon sx={{ fontSize: 16 }} />
        </Box>
      </CardContent>
    </CardActionArea>
  </Card>
);

const Ourservices = () => (
  <Box
    id="services"
    sx={{
      background: 'linear-gradient(180deg, #f0f2ff 0%, #ffffff 100%)',
      py: { xs: 8, md: 12 },
    }}
  >
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
        <Typography
          component="span"
          sx={{
            display: 'inline-block',
            background: 'rgba(5, 15, 102, 0.07)',
            color: '#050f66',
            fontWeight: 700,
            fontSize: '13px',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            px: 2,
            py: 0.8,
            borderRadius: '20px',
            mb: 2,
          }}
        >
          Our Services
        </Typography>
        <Typography
          component="h2"
          sx={{
            color: '#0d1757',
            fontSize: { xs: '2rem', md: '2.8rem' },
            fontWeight: 800,
            mb: 2,
            lineHeight: 1.15,
          }}
        >
          What We Offer
        </Typography>
        <Typography
          sx={{
            color: '#6b7280',
            fontSize: { xs: '1rem', md: '1.1rem' },
            maxWidth: '560px',
            mx: 'auto',
            lineHeight: 1.7,
          }}
        >
          Comprehensive streaming and digital solutions, all customized to your unique needs and
          requirements.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {allservices.map((service) => (
          <Grid item xs={12} sm={6} md={3} key={service.name}>
            <ServiceCard data={service} />
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default Ourservices;
